import React, { useState } from 'react';
import { useI18n } from '../../contexts/I18nContext';
import PricingPlans from '../PricingPlans/PricingPlans';
import './Pricing.scss';

const Pricing = () => {
  const [expandedFaq, setExpandedFaq] = useState(null);
  const { t } = useI18n();

  const faqs = [
    {
      question: t('pricing.faq1Question'),
      answer: t('pricing.faq1Answer')
    },
    {
      question: t('pricing.faq2Question'),
      answer: t('pricing.faq2Answer')
    },
    {
      question: t('pricing.faq3Question'),
      answer: t('pricing.faq3Answer')
    },
    {
      question: t('pricing.faq4Question'),
      answer: t('pricing.faq4Answer')
    },
    {
      question: t('pricing.faq5Question'),
      answer: t('pricing.faq5Answer')
    },
    {
      question: t('pricing.faq6Question'),
      answer: t('pricing.faq6Answer')
    }
  ];

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  return (
    <div className="pricing-page">
      <PricingPlans 
        showHeader={true} 
        showBillingToggle={true} 
      />

      <div className="faq-section">
        <div className="faq-header">
          <h2>{t('pricing.faqTitle')}</h2>
          <p>{t('pricing.faqSubtitle')}</p>
        </div>
        
        <div className="faq-items">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${expandedFaq === index ? 'expanded' : ''}`}>
              <button 
                className="faq-question"
                onClick={() => toggleFaq(index)}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">{expandedFaq === index ? '−' : '+'}</span>
              </button>
              {expandedFaq === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pricing;